import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import "./Regole.css";

export default function Regole() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="regole-container">
      <Navbar backButton />

      <div className="regole-content">
        <h1 className="regole-title">Regole del gioco</h1>

        <p className="regole-subtitle">
          <strong>Scegli il tuo avatar e inizia a tirare!</strong>
        </p>

        <div className="regole-text">
          <p>
            Scala la classifica realizzando{" "}
            <strong>più canestri possibili durante i quarti di gioco.</strong>
          </p>
          <p>
            All'intervallo lo speaker annuncerà{" "}
            <strong>i primi tre classificati</strong>, che scenderanno sul
            parquet per effettuare <strong>tre tiri liberi</strong> davanti a
            tutto il pubblico.
          </p>
          <p>
            <strong>
              Al termine della partita, il primo classificato vincerà una maglia
              ufficiale del Napoli Basketball!
            </strong>
          </p>
        </div>

        <button className="back-button-bottom" onClick={handleBack}>
          TORNA INDIETRO
        </button>
      </div>
    </div>
  );
}
